<div class="modal modal--center modal-invitation-reopen" [ngClass]="{'active': isActive}" modal>
    <div class="modal__overlay"></div>

    <div class="modal__content" style="min-width: 600px; max-width: 800px; width: 90vw;">
        <div class="modal__header">
            <div class="modal__close">
                <i class="icon icon-close" (click)="close()"></i>
            </div>

            <h2 class="modal__title">
                {{ 'user.pending-invitations' | translate }} ({{ isLoading ? (counts?.invitationCount || 0) : totalCount }})
            </h2>
        </div>

        <div class="px-6 pb-4">
            <input
                type="text"
                class="border border-gray-200 rounded-lg px-3 py-2 w-full text-sm"
                [placeholder]="'common.search' | translate"
                [value]="searchQuery"
                (input)="onSearch($event.target['value'])">
        </div>

        <div class="modal__body p-0" style="min-height: 200px; max-height: 400px; overflow-y: auto;">
            <div *ngIf="isLoading" class="flex justify-center items-center py-10">
                <msc-common-spinner></msc-common-spinner>
            </div>

            <div *ngIf="!isLoading && invitations.length === 0" class="flex flex-col items-center py-10 text-gray-400">
                <i class="icon icon-email text-3xl mb-3"></i>
                <p class="text-sm">{{ 'user.no-pending-invitations' | translate }}</p>
            </div>

            <table *ngIf="!isLoading && invitations.length > 0" class="w-full">
                <thead class="border-b bg-gray-50 sticky top-0">
                    <tr>
                        <th class="px-4 py-3 w-10">
                            <msc-common2-checkbox
                                [value]="allCurrentPageSelected"
                                (changeEvent)="toggleSelectAll()">
                            </msc-common2-checkbox>
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {{ 'words.user' | translate }}
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {{ 'words.date' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let invitation of invitations"
                        class="border-b hover:bg-gray-50 cursor-pointer"
                        (click)="toggleSelect(invitation.id)">
                        <td class="px-4 py-3" (click)="$event.stopPropagation()">
                            <msc-common2-checkbox
                                [value]="isSelected(invitation.id)"
                                (changeEvent)="toggleSelect(invitation.id)">
                            </msc-common2-checkbox>
                        </td>
                        <td class="px-4 py-3">
                            <p class="text-sm font-medium text-gray-900">
                                <ng-container *ngIf="invitation.firstname || invitation.lastname">
                                    {{ invitation.firstname }} {{ invitation.lastname }}
                                </ng-container>
                                <ng-container *ngIf="!invitation.firstname && !invitation.lastname">—</ng-container>
                            </p>
                            <p class="text-xs text-gray-400">{{ invitation.email }}</p>
                        </td>
                        <td class="px-4 py-3 text-xs text-gray-400 whitespace-nowrap">
                            {{ invitation.invitationDate | date:'dd/MM/yyyy' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="!isLoading && (totalPages > 1 || selectedCount > 0)" class="px-4 py-3 border-t flex items-center justify-between">
            <div *ngIf="totalPages > 1" class="flex items-center space-x-2 text-sm text-gray-500">
                <button
                    class="p-1 rounded hover:bg-gray-100 disabled:opacity-40"
                    [disabled]="currentPage === 1"
                    (click)="goToPage(currentPage - 1)">
                    <i class="icon icon-arrow-ios-left"></i>
                </button>
                <span>{{ currentPage }} / {{ totalPages }}</span>
                <button
                    class="p-1 rounded hover:bg-gray-100 disabled:opacity-40"
                    [disabled]="currentPage === totalPages"
                    (click)="goToPage(currentPage + 1)">
                    <i class="icon icon-arrow-ios-right"></i>
                </button>
            </div>
            <div *ngIf="totalPages <= 1"></div>

            <div class="flex items-center space-x-2">
                <span *ngIf="selectedCount > 0" class="text-xs text-gray-400 mr-2">
                    {{ selectedCount }} {{ 'words.selected' | translate }}
                </span>
                <msc-button
                    class="msc-button--primary"
                    palette="primary"
                    [disabled]="selectedCount === 0 || isSending"
                    (click)="resendSelected()">
                    {{ 'words.reinvite' | translate }}<ng-container *ngIf="selectedCount > 0"> ({{ selectedCount }})</ng-container>
                </msc-button>
                <msc-button
                    [disabled]="selectedCount === 0 || isSending"
                    (click)="deleteSelected()">
                    {{ 'words.delete' | translate }}<ng-container *ngIf="selectedCount > 0"> ({{ selectedCount }})</ng-container>
                </msc-button>
            </div>
        </div>

        <div *ngIf="!isLoading && invitations.length > 0 && selectedCount === 0 && totalPages <= 1"
            class="px-4 py-3 border-t flex justify-end space-x-2">
            <msc-button
                class="msc-button--primary"
                palette="primary"
                [disabled]="selectedCount === 0 || isSending"
                (click)="resendSelected()">
                {{ 'words.reinvite' | translate }}
            </msc-button>
            <msc-button
                [disabled]="selectedCount === 0 || isSending"
                (click)="deleteSelected()">
                {{ 'words.delete' | translate }}
            </msc-button>
        </div>
    </div>
</div>
